import { render, staticRenderFns } from "./SpeakerMessage.vue?vue&type=template&id=02a831e7&scoped=true&"
import script from "./SpeakerMessage.vue?vue&type=script&lang=js&"
export * from "./SpeakerMessage.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerMessage.vue?vue&type=style&index=0&id=02a831e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a831e7",
  null
  
)

export default component.exports